import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=82b34db8"
import script from "./region.js?vue&type=script&lang=js&external"
export * from "./region.js?vue&type=script&lang=js&external"
import style0 from "./region.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports